'use strict';
define([], function () {
    function SEOCheckerCtrl($scope, AuthService, SuiteNavigation) {
        $scope.authenticated = AuthService.isAuthenticated();
        $scope.toggleSuiteNavigation = SuiteNavigation.toggle;
    }

    SEOCheckerCtrl.$inject = ['$scope', 'AuthService', 'SuiteNavigation'];
    return SEOCheckerCtrl;
});
